import React, { useEffect, useRef } from 'react';
import { Eraser } from 'lucide-react';

// Firma col dito: il PNG ha lo sfondo trasparente, il bianco è solo a schermo
export const SignaturePad = ({ onChange, testid }) => {
  const ref = useRef(null);
  const attivo = useRef(false);
  const ctx = () => ref.current.getContext('2d');

  useEffect(() => {
    const c = ref.current;
    const r = c.getBoundingClientRect();
    const dpr = window.devicePixelRatio || 1;
    c.width = r.width * dpr;
    c.height = r.height * dpr;
    const g = c.getContext('2d');
    g.scale(dpr, dpr);
    Object.assign(g, { lineWidth: 2.6, lineCap: 'round', lineJoin: 'round', strokeStyle: '#1d2b6b' });
  }, []);

  const punto = (e) => { const r = ref.current.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  const giu = (e) => {
    e.preventDefault();
    ref.current.setPointerCapture(e.pointerId);
    attivo.current = true;
    const [x, y] = punto(e);
    ctx().beginPath(); ctx().moveTo(x, y); ctx().lineTo(x + 0.1, y + 0.1); ctx().stroke();
  };
  const muovi = (e) => { if (!attivo.current) return; const [x, y] = punto(e); ctx().lineTo(x, y); ctx().stroke(); };
  const su = () => { if (!attivo.current) return; attivo.current = false; onChange(ref.current.toDataURL('image/png')); };
  const cancella = () => { const c = ref.current; ctx().clearRect(0, 0, c.width, c.height); onChange(null); };

  return (
    <div className="space-y-1.5">
      <canvas ref={ref} onPointerDown={giu} onPointerMove={muovi} onPointerUp={su} onPointerLeave={su} data-testid={testid}
        className="w-full h-40 rounded-xl border-2 border-dashed border-sky-400 touch-none cursor-crosshair" style={{ background: '#fff' }} />
      <div className="flex items-center justify-between">
        <span className="text-[11px] text-gray-500">Firma col dito nel riquadro</span>
        <button type="button" onClick={cancella} data-testid={`${testid}-cancella`} className="text-xs text-gray-600 flex items-center gap-1"><Eraser className="h-3.5 w-3.5" />Cancella</button>
      </div>
    </div>
  );
};
